// File: src/components/AutoLogoutHandler.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AutoLogoutHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let timeout;

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        localStorage.removeItem('jwt');
        localStorage.removeItem('user');
        navigate('/login');
      }, 60 * 60 * 1000); // 10 minutes
    };

    const events = ['mousemove', 'keydown', 'scroll', 'click'];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      clearTimeout(timeout);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [navigate]);

  return null;
};

export default AutoLogoutHandler;
